import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TITLES = {
  "/": "Tableau de bord",
  "/reports": "Rapports & Stats",
  "/seller-report": "Rapport vendeurs & stock",
  "/cancellations": "Journal des annulations",
  "/locations": "Emplacements",
  "/supplies": "Approvisionnements",
  "/returns": "Retours clients",
  "/pos": "Ventes",
  "/receivables": "Créances",
  "/quotes": "Devis",
  "/stock": "Stock",
  "/products": "Catalogue",
  "/categories": "Catégories",
  "/parties": "Clients & Fournisseurs",
  "/purchases": "Achats / Fournisseurs",
  "/cash": "Caisse",
  "/expenses": "Dépenses",
  "/hr": "Ressources humaines",
  "/fleet": "Logistique / Camion",
  "/rentals": "Locations & actifs",
  "/deliveries": "Livraisons",
  "/activities": "Activités",
  "/users": "Utilisateurs",
  "/audit": "Audit de sécurité",
  "/settings": "Paramètres",
  "/account": "Mon compte",
  "/guide": "Guide de démarrage",
  "/formation": "Formation",
  "/admin": "Administration",
  "/login": null,
  "/reset-password": null,
};

export default function PageTitle() {
  const loc = useLocation();
  useEffect(() => {
    const name = Object.prototype.hasOwnProperty.call(TITLES, loc.pathname)
      ? TITLES[loc.pathname]
      : "Biashara";
    document.title = name ? `${name} | Biashara` : "Biashara";
  }, [loc.pathname]);
  return null;
}
